import React, { useRef, useState } from 'react'
import { DateRangeType, DateType } from '../../../_config/types'
import DateRangePicker from '@wojtekmaj/react-daterange-picker'
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';

import Icon from '../../icons'
import Label from './fromLabel'
import Error from './fromError'
import moment, { Moment } from 'moment';


type TimepickerProps = {
    type?: 'range' | null
    value?: Moment | undefined
    onChange?: (value: Moment | undefined) => void
    minDate?: Date | undefined
    maxDate?: Date | undefined
    format?: string
    clearIcon?: React.ReactNode
    calendarIcon?: React.ReactNode
    error?: string
    className?: string
    disabled?: boolean
    required?: boolean
    info?: string
    label?: string
}

const Timepicker: React.FC<TimepickerProps> = ({ disabled = false, required, info, label, type = null, value, onChange , minDate = undefined, maxDate = undefined, format = 'hh:mm A', clearIcon = null, calendarIcon = null, error, className = '' }) => {
    //const [isOpen, setIsOpen] = useState<boolean>(false);


    return (
        <div className={`my-6 ${className}`}>
            {label && <Label text={label} required={required} info={info} />}

            <div className={`relative flex items-center min-w-[13.150rem] mt-2 rounded-[0.267rem] w-full ${className}`}>

                <TimePicker
                    showSecond={false}
                    value={value}
                    onChange={onChange}
                    format={format}
                    use12Hours
                    className={`rounded-[0.267rem] bg-white text-[0.667rem] flex items-center w-full min-w-[4rem] h-[2.875rem] text-start ${error ? 'border-red-500 border-2' : 'border border-[#D4D4DA]'}`}
                   
                   //disabled={disabled}
                 
                    /* clearIcon={<Icon name='reset' size={1} />} */
                   /*  calendarIcon={<Icon name='calendar' size={1} />} */
                />
            </div>

            {error && <Error message={error} />}
        </div>


    )
}

export default Timepicker